import { render } from "./ProductsListProductDescription.vue?vue&type=template&id=0d925b96"
import script from "./ProductsListProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductsListProductDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__